import styled from 'styled-components'
import { MOBILE_WIDTH } from 'utils/constants'
import { ReceiptType } from './types'

const TYPE_COLORS: Record<ReceiptType, { background: string; color: string }> = {
  payment: { background: '#DCE6D3', color: '#464F31' },
  refund: { background: '#FBE2D2', color: '#8A4A17' },
  complement: { background: '#D8E3EC', color: '#2C4A63' }
}

export const ReceiptsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  width: 100%;
  background: #f8f8f8;
  padding: 2rem;

  border-radius: 0.5rem;
  height: fit-content;

  @media ${MOBILE_WIDTH} {
    padding: 1rem;
  }
`

export const Description = styled.p`
  font-size: 1rem;
  color: #777777;
`

export const ReceiptsList = styled.section`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const ReceiptCard = styled.article`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;

  background: #ffffff;
  border: 1px solid #e0e7ec;
  border-radius: 0.5rem;
  padding: 1.25rem 1.5rem;

  @media ${MOBILE_WIDTH} {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }
`

export const ReceiptInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.375rem;

  strong {
    font-size: 1.125rem;
    font-weight: 600;
    color: #3d3d3d;
  }

  span {
    font-size: 0.875rem;
    color: #777777;
  }
`

export const TypeBadge = styled.span<{ type: ReceiptType }>`
  align-self: flex-start;

  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.02em;

  padding: 0.25rem 0.625rem;
  border-radius: 1rem;

  background: ${({ type }) => TYPE_COLORS[type].background};
  color: ${({ type }) => TYPE_COLORS[type].color};
`

export const ReceiptActions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;

  @media ${MOBILE_WIDTH} {
    width: 100%;

    > * {
      flex: 1;
    }
  }
`

export const DownloadLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;

  height: 45px;
  padding: 0 1.25rem;

  border-radius: 0.5rem;
  background: var(--app-green-dark, #464f31);
  color: #ffffff;
  font-size: 0.875rem;
  font-weight: 600;

  transition: filter 0.2s;

  &:hover {
    filter: brightness(1.15);
    color: #ffffff;
  }
`

export const PreviewFrame = styled.iframe`
  width: 70vw;
  max-width: 900px;
  height: 75vh;
  border: none;

  @media ${MOBILE_WIDTH} {
    width: 100%;
    height: 65vh;
  }
`

export const FilterNotice = styled.p`
  font-size: 0.875rem;
  color: #3d3d3d;

  background: #eef3f7;
  border-radius: 0.5rem;
  padding: 0.75rem 1rem;

  a {
    color: var(--app-green-dark, #464f31);
    font-weight: 600;
    text-decoration: underline;
  }
`
